<form id="payment_form" class="focus-pay-datacap-input mt-2">
	<div class="p-grid">
		<div class="p-col-12 justify-content-center text-center">
			<div id="apple-pay-button"></div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-0">
			<div class="w-100">
				<div class="p-inputgroup w-100">
					<input
						pInputText
						type="text"
						placeholder="card number"
						data-token="card_number"
						[(ngModel)]="payApiPaymentRequest.displayCardNumber"
						[ngModelOptions]="{ standalone: true }"
						class="w-100"
						(keyup)="evalCCInput(payApiPaymentRequest.displayCardNumber)"
						autocomplete="cc-number"
						(ngModelChange)="evalForm()"
						[maxlength]="cardLength()"
						[minlength]="cardLength()"
						[disabled]="processing"
						required
						ccNumber
					/>

					<span class="p-inputgroup-addon">
						<fa-icon
							*ngIf="!processing"
							[icon]="[creditCardProperties.iconGroup, creditCardProperties.icon]"
							size="xl"
							class="my-auto mx-auto card-type-icon"
							[ngClass]="creditCardProperties.valid ? 'valid' : 'invalid'"
						></fa-icon>
						<fa-icon
							*ngIf="processing"
							[icon]="['far', 'shield-keyhole']"
							size="xl"
							class="my-auto mx-auto card-type-icon"
							[ngClass]="creditCardProperties.valid ? 'valid' : 'invalid'"
						></fa-icon>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="p-grid" *ngIf="creditCardProperties.status">
		<div class="p-col-12">
			<div class="d-flex w-100 text-italics display-14">
				{{ creditCardProperties.status }}
			</div>
		</div>
	</div>
	<div class="p-grid mt-1">
		<div class="p-col-6 ps-0 pe-1 py-0">
			<p-dropdown
				#expirationMonthSelect
				[options]="app.references.months"
				optionLabel="label"
				optionValue="value"
				name="expirationMonthSelect"
				[(ngModel)]="payApiPaymentRequest.expirationMonth"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				(filterBy)="app.keys(app.references.months)"
				placeholder="month"
				(ngModelChange)="evalForm()"
				[disabled]="processing"
			></p-dropdown>
		</div>
		<div class="p-col-6 ps-1 pe-0 py-0">
			<p-dropdown
				#expirationYearSelect
				[options]="app.references.years"
				optionLabel="label"
				optionValue="value"
				name="expirationYearSelect"
				[(ngModel)]="payApiPaymentRequest.expirationYear"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				placeholder="year"
				(ngModelChange)="evalForm()"
				[disabled]="processing"
			></p-dropdown>
		</div>
	</div>
	<div class="p-grid mt-1">
		<div class="p-col-6 ps-0 pe-1 py-0">
			<input
				pInputText
				#cvvInput
				name="cvvInput"
				type="text"
				[(ngModel)]="payApiPaymentRequest.cvv"
				class="w-100"
				placeholder="cvv"
				[disabled]="processing"
				(ngModelChange)="evalForm()"
			/>
		</div>
		<div class="p-col-6 ps-1 pe-0 py-0">
			<input
				pInputText
				type="text"
				placeholder="zip"
				name="zipcodeInput"
				[(ngModel)]="payApiPaymentRequest.postalCode"
				class="w-100"
				minlength="5"
				maxlength="5"
				[disabled]="processing"
				(ngModelChange)="evalForm()"
			/>
		</div>
	</div>
	<div class="p-grid mt-1">
		<div class="p-col-9 px-0">
			<p-button
				pRipple
				styleClass="p-button-raised payment-button w-100 px-auto"
				[ngClass]="!payApiPaymentRequest.validInput ? 'disabled' : ''"
				[disabled]="evalForm() || processing"
				(click)="submit()"
				[loading]="processing"
				label="Submit"
				icon="pi pi-check"
			></p-button>
		</div>
		<div class="p-col-3 p-0">
			<div class="d-flex h-100 mx-auto my-auto">
				<img
					class="focus-pay-image"
					src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/secured-by-focusPay.png"
					alt="secured by FocusPay"
				/>
			</div>
		</div>
		<input type="hidden" id="token" [(ngModel)]="payApiPaymentRequest.token" [ngModelOptions]="{ standalone: true }" />
		<input type="hidden" data-token="exp_month" [(ngModel)]="payApiPaymentRequest.expirationMonth" [ngModelOptions]="{ standalone: true }" />
		<input type="hidden" data-token="exp_year" [(ngModel)]="payApiPaymentRequest.expirationYear" [ngModelOptions]="{ standalone: true }" />
		<input type="hidden" data-token="cvv" [(ngModel)]="payApiPaymentRequest.cvv" [ngModelOptions]="{ standalone: true }" />
	</div>
</form>
